import React, { useEffect, useState } from "react";
import { ProfileBeaconPopover } from "./ProfileBeaconComponents";
import styled from "styled-components";
import {ReactComponent as ToolTipClickedIcon} from "../../assets/TooltipClicked.svg";
import {ReactComponent as ToolTipIcon} from "../../assets/tooltip.svg";


const StyledPopoverButton = styled.button`
  background-color: white;
  border: none;
  padding: 0;
  text-align: left;
`;

const StyledActiveStyle = styled.span`
  --beacon-button-space-padding-block-start-normal: 0;
  --beacon-custom-popover-z-index: 1000;
  line-height: 1.5;
  letter-spacing: 0.02px;
  font-size: 18px;
  font-weight: normal;
  border-bottom: 1px dotted #086ea1;
  width: auto;
  color: #ffffff;
  background-color: #086ea1;
  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

const StyledTextAlertsTitle = styled.span`
    color: #3b4b59;
    font-size: 18px;
    font-weight: normal;
    line-height: 1.5;
    letter-spacing: 0.02px;
    border-bottom: 1px dotted #086ea1;
    width: auto;
      @media (max-width: 768px) {
        font-size: 16px;
      }
`;
const Popover = ({ id, label, popoverTitle, popoverContent }) => {
    const [popoverOpen,setPopoverOpen] = useState(false);
    useEffect(() => {
        const modalInstance = document.getElementById(id);
        const openListener = () => {
            setPopoverOpen(true);
        }
        const closeListener = () => {
            setPopoverOpen(false);
        }
        modalInstance && modalInstance.addEventListener('beacon-event-open', openListener);
        modalInstance && modalInstance.addEventListener('beacon-event-close', closeListener);
        return () => {
            modalInstance && modalInstance.addEventListener('beacon-event-open', openListener);
            modalInstance && modalInstance.addEventListener('beacon-event-close', closeListener);
        }
    },[id]);

    return (
        <ProfileBeaconPopover
            id = {id}
            popoverTitle={" "}
            content={popoverContent}
            >
            <StyledPopoverButton aria-label={label} onClick={()=> setPopoverOpen(!popoverOpen)}>

                {(popoverTitle !== " ") && (popoverOpen ?
                    <StyledActiveStyle>{popoverTitle}</StyledActiveStyle> :
                    <StyledTextAlertsTitle>{popoverTitle}</StyledTextAlertsTitle>)}
                {(popoverTitle === " ") && (popoverOpen ? <ToolTipClickedIcon/> : <ToolTipIcon/>)}

            </StyledPopoverButton>
        </ProfileBeaconPopover>
    )
}

export default Popover;
